/** Curate search on Semantic Scholar + OpenAlex (OpenAlex slice 1b).
 *
 * Only called when `concept.search_preview_enabled` (backend ring gate);
 * everyone else keeps the /api/s2 proxy path in `s2-client.ts`.
 */
import apiClient from "@/lib/api-client";

export type InConcept = "none" | "active" | "dismissed";

export interface ConceptSearchResult {
  paper_id: string;
  title: string;
  authors: string[];
  year: number | null;
  abstract: string | null;
  doi: string | null;
  citation_count: number;
  sources: string[];
  in_concept: InConcept;
}

export interface ConceptSearchResponse {
  results: ConceptSearchResult[];
  query_used: string;
  oa_only_count: number;
  /** "off": user outside the OpenAlex ring — Semantic Scholar only. */
  openalex_status: "ok" | "unavailable" | "off";
  /** Narrower variants searched because the query alone found too little. */
  rescue_queries?: string[];
}

export function searchConcept(
  conceptId: string,
  q: string,
  limit = 50,
): Promise<ConceptSearchResponse> {
  return apiClient
    .get(`api/concepts/${conceptId}/search`, {
      searchParams: { q, limit },
      timeout: 120_000,
    })
    .json<ConceptSearchResponse>();
}
